import { render, staticRenderFns } from "./TransferWpAttachments.vue?vue&type=template&id=3e4b66fe&"
import script from "./TransferWpAttachments.vue?vue&type=script&lang=js&"
export * from "./TransferWpAttachments.vue?vue&type=script&lang=js&"
import style0 from "./TransferWpAttachments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports